<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import Table from "../../../base-components/Table";
import Preview from "../../../base-components/Preview";
import Button from "../../../base-components/Button";
import Lucide from "../../../base-components/Lucide/Lucide.vue";
import { Menu } from "../../../base-components/Headless";
import { useUsuariosInvitacionesStore } from "../../../services/usuariosInvitaciones";
import ModalCancelarInvitacion from "./modals/ModalCancelarInvitacion.vue";
import ModalReenviarInvitacion from "./modals/ModalReenviarInvitacion.vue";
import { userUserStore } from "../../../stores/user";
import { useUsuarioRolesStore } from "../../../services/usuarioRoles";
import { UsuarioSistemaInvitacion } from "@fixeduy/restaurantestypes";

const usuariosSistemasInvitacionesStore = useUsuariosInvitacionesStore();
const userStore = userUserStore();
const usuariosRolesStore = useUsuarioRolesStore();

onBeforeMount(() => {
  if (usuariosRolesStore.roles.length == 0) {
    usuariosRolesStore.getRolesFromFirestore();
  }
});

onBeforeMount(() => {
  usuariosSistemasInvitacionesStore.init();
});

enum showModalType {
  none,
  CancelarInvitacion,
  ReenviarInvitacion
}

const modal = ref<showModalType>(showModalType.none);
const usuarioInvitacionSeleccionado = ref<UsuarioSistemaInvitacion | null>(
  null
);

const showModal = (
  usuario: UsuarioSistemaInvitacion,
  modalShow: showModalType
) => {
  modal.value = modalShow;
  usuarioInvitacionSeleccionado.value = usuario;
};

const cerrarModal = () => {
  modal.value = showModalType.none;
  usuarioInvitacionSeleccionado.value = null;
};
</script>

<template>
  <div v-if="usuariosSistemasInvitacionesStore.documentos.length > 0">
    <Preview class="mt-5 pb-5 box">
      <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2 p-5">
          <h2 class="text-base font-medium">Invitaciones a usuarios</h2>
        </div>
      </div>
      <div class="px-5">
        <Preview.Panel>
          <Table hover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th class="whitespace-nowrap"> Usuario</Table.Th>
                <Table.Th class="whitespace-nowrap"> Rol</Table.Th>
                <Table.Th class="whitespace-nowrap"> Agregado por</Table.Th>
                <Table.Th class="whitespace-nowrap"></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <Table.Tr
                v-for="usuario in usuariosSistemasInvitacionesStore.documentos"
                :key="usuario.id"
              >
                <Table.Td
                  >{{ usuario.nombre }}<br />{{ usuario.mail }}</Table.Td
                >
                <Table.Td>{{
                  usuariosRolesStore.getRolById(usuario.rolId)?.rol
                }}</Table.Td>
                <Table.Td
                  >{{ usuario.enviadaPorNombre }}<br />{{
                    usuario.enviadaPorMail
                  }}<br />{{ usuario.enviadaElString }}</Table.Td
                >
                <Table.Td>
                  <div class="flex items-right justify-center">
                    <Menu>
                      <Menu.Button :as="Button" class="px-2 !box">
                        <span class="flex items-right justify-center w-5 h-5">
                          <Lucide icon="Plus" class="w-4 h-4" />
                        </span>
                      </Menu.Button>
                      <Menu.Items class="w-40" placement="left-end">
                        <Menu.Item
                          @click="
                            showModal(usuario, showModalType.ReenviarInvitacion)
                          "
                        >
                          <Lucide icon="MailPlus" class="w-4 h-4 mr-2" />
                          Volver a enviar mail
                        </Menu.Item>
                        <Menu.Item
                          @click="
                            showModal(usuario, showModalType.CancelarInvitacion)
                          "
                        >
                          <Lucide icon="Trash2" class="w-4 h-4 mr-2" />
                          Cancelar invitación
                        </Menu.Item>
                      </Menu.Items>
                    </Menu>
                  </div>
                </Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        </Preview.Panel>
      </div>
      <ModalCancelarInvitacion
        v-if="
          modal == showModalType.CancelarInvitacion &&
          usuarioInvitacionSeleccionado != null
        "
        :usuario="usuarioInvitacionSeleccionado!"
        @cerrar-invitacion="cerrarModal"
      />
      <ModalReenviarInvitacion
        v-if="
          modal == showModalType.ReenviarInvitacion &&
          usuarioInvitacionSeleccionado != null
        "
        :usuario="usuarioInvitacionSeleccionado!"
        @cerrarInvitacion="cerrarModal"
      />
    </Preview>
  </div>
</template>
